import type { Theme } from '@mui/material';

const ERROR_REASONS = ['registered_call_timeout', 'concurrency_limit_reached'];
const POLICY_REASONS = ['inbound_country_blocked', 'payment_overdue'];

// Colors for Interaction#disconnection_reason codes (backend utils/disconnection_reasons.yml).
export function getEndReasonBadgeColor(reason: string, theme: Theme) {
  if (reason.startsWith('error_') || ERROR_REASONS.includes(reason)) {
    return { bg: theme.palette.error.light, main: theme.palette.error.main };
  }
  if (reason.includes('transfer') || reason === 'call_take_over') {
    return { bg: theme.palette.primary.light, main: theme.palette.primary.main };
  }
  if (POLICY_REASONS.includes(reason)) {
    return { bg: '#ECECEC', main: '#777777' };
  }
  return { bg: '#F5DFFF', main: '#7C00B1' };
}
